export const getPermission = (loggedData: any) => {
  if (!loggedData?.subMenus?.length) return null;

  const validation = loggedData?.subMenus?.some((x) => x?.smCode?.includes(loggedData?.path));

  if (loggedData?.uDashboardAccess === 2 && loggedData?.path === '/') {
    return false;
  }

  return validation;
};
